var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.4375 0C2.52582 0 1.65148 0.376274 1.00682 1.04605C0.362164 1.71582 0 2.62423 0 3.57143V16.4286C0 17.3758 0.362164 18.2842 1.00682 18.954C1.65148 19.6237 2.52582 20 3.4375 20H18.5625C19.4742 20 20.3485 19.6237 20.9932 18.954C21.6378 18.2842 22 17.3758 22 16.4286V3.57143C22 2.62423 21.6378 1.71582 20.9932 1.04605C20.3485 0.376274 19.4742 0 18.5625 0H3.4375ZM9.30188 5.82286L14.8019 9.39714C14.8992 9.46057 14.9797 9.54833 15.0359 9.6524C15.0922 9.75646 15.1225 9.87352 15.124 9.99286C15.1255 10.1122 15.0982 10.2301 15.0445 10.3356C14.9909 10.4412 14.9127 10.5311 14.817 10.5971L9.317 14.3814C9.21339 14.4527 9.09313 14.4934 8.969 14.4994C8.84487 14.5053 8.72152 14.4761 8.61207 14.415C8.50261 14.3539 8.41115 14.2631 8.34739 14.1523C8.28364 14.0415 8.24998 13.9148 8.25 13.7857V6.42857C8.25 6.30107 8.28285 6.17589 8.34514 6.06603C8.40743 5.95617 8.49688 5.86564 8.60422 5.80383C8.71156 5.74202 8.83286 5.71118 8.95554 5.71453C9.07823 5.71788 9.19781 5.75528 9.30188 5.82286Z",
    fill: "#949494"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.c6cbfc4e50e92229ffc66b0f0b59602a.svg";
export { ForwardRef as ReactComponent };